import { call, fork, select, takeEvery } from 'redux-saga/effects';

import { fetchLocation } from '../api'
import { locationsActions } from './actions';
import { getLocationById } from './selectors';

export function* loadLocationsList({payload}) {

  const { id, sessionId } = payload;

  const location = yield select(getLocationById, id);
  if ( id && !location ) {
    yield call(fetchLocation, id, { locationId: id, sessionId });
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadLocations() {
  yield takeEvery(locationsActions.LOAD_LOCATION, loadLocationsList);
}

//=====================================
//  ROOT
//-------------------------------------

export const locationsSagas = [
  fork(watchLoadLocations),
];
